module.exports = __webpack_public_path__ + "assets/img/frame-team-tablet.35e454f1.png";